import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo} from 'react'
import {Formik} from "formik";
import {NullAsDefault} from 'views/Shared'
import FieldsFactory from "./FieldsFactory";
import FormActionBar from "./FormActionBar";
import DrawDialog from "../drawer/dialog/DrawDialog";
import _ from "lodash";
import {shallowDiff} from "../../views/Shared";
import {LayoutContext} from "../layouts/Default/LayoutContext";
import {Avatar} from "antd";
import {BiSolidLabel} from "react-icons/bi";


export const PartialEditForm = ({
                                    initialValues,
                                    onCancel = NullAsDefault,
                                    onSubmit = NullAsDefault,
                                    formSchemas = [],
                                    onValidate = (values, t) => {
                                        return {};
                                    }
                                }
) => {
    const t = useTranslate()

    const _initialValues = useMemo(
        () => ({
            ...initialValues
        }),
        [initialValues]
    )

    const _onValidate = useCallback(
        (values) => onValidate(values, t),
        []
    )
    return (
        <Formik
            validate={_onValidate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={onSubmit}>
            <div className="w-full flex flex-col gap-4 py-3">
                <FieldsFactory
                    formSchema={formSchemas}
                />
                <FormActionBar hideResetButton={true} submitText="save"/>
            </div>
        </Formik>
    )
}


export const PartialEditGroupWrapper = ({
                                            item,
                                            initialValues,
                                            onCancel = NullAsDefault,
                                            onSubmit = NullAsDefault,
                                            groupFields = []
                                        }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)

    return (
        <div className="flex flex-col gap-6">
            {groupFields.map((e, i) => (!!item && !!e) && (
                <div key={i} className="w-full flex flex-col rounded-lg">
                    <div className="flex items-center flex-1">
                        <Avatar
                            size={26}
                            icon={<BiSolidLabel size={14} className="text-color-500"/>}
                            className="flex flex-center background rounded-md"
                        />
                        <div
                            style={{
                                padding: '0.5rem 0.75rem 0.5rem 1.5rem',
                                marginLeft: -16,
                                borderRadius: '0.5rem 0.5rem 0.15rem 0.15rem',
                            }}
                            className="flex-1 p-2 background-200 rounded-md font-medium text-color-300 tracking-wider">
                            {t(e?.title)}
                        </div>
                    </div>
                    <div
                        style={{marginLeft: '0.75rem', padding: '0.75rem'}}
                        className="flex flex-col md:flex-row items-end md:items-center gap-3 border-b border-color-100 hover:border-color-300 background rounded-b-lg shadow-xs">
                        <div className="ml-0 md:ml-1 w-full flex-1">
                            {e?.render(item) || (
                                <span className="text-color-400 italic tracking-wider">
                                    {`${t('no data to display yet')}...`}
                                </span>
                            )}
                        </div>
                        {
                            !!!e?.viewOnly && (
                                <DrawDialog
                                    width={600}
                                    title={
                                        <div className="text-center font-bold text-color-000 tracking-wider">
                                            {t(e?.title || 'edit')}
                                        </div>
                                    }
                                    closable={false}
                                    component={
                                        <div
                                            className="font-medium text-xs text-blue-500 hover:text-blue-700 tracking-wider cursor-pointer">
                                            {t("edit")}
                                        </div>
                                    }>
                                    {(isToggle, toggle) => isToggle && (
                                        <PartialEditForm
                                            formSchemas={e.formSchemas}
                                            initialValues={initialValues}
                                            onValidate={e.onValidate}
                                            onSubmit={({...values}) => {
                                                const changes = shallowDiff(values, initialValues)

                                                onSubmit(_.omitBy(
                                                    {
                                                        ...changes,
                                                    },
                                                    _.isUndefined
                                                ))
                                                setTimeout(() => {
                                                    toggle();
                                                }, 500);
                                            }}
                                            onCancel={(e) => {
                                                onCancel(e);
                                                toggle();

                                            }}
                                        />
                                    )}
                                </DrawDialog>
                            )}
                    </div>
                </div>
            ))}
        </div>
    )
}
